import { Component, Input } from "@angular/core";
import { BlockBaseComponent } from "../../scene-blocks/block-base/block-base.component";
import { copyTextClipboard, isHostDevOrLocal, TOAST_FASTER } from "../../../../common";
import { StoreSelectorsService } from "../../../../services";
import { actionCopySceneAnimation, actionRemoveInSceneItem, actionUpdateSceneItem } from "../../../../store/actions/user.actions";
import { IAnimationEngine } from "../../../../interfaces";
import { animationDefault } from "../../scene-blocks/block-constants";
import { DialogPopComponent } from "../../../../components/dialog-pop/dialog-pop.component";
import { ToastrService } from "ngx-toastr";
import { TranslocoService } from "@ngneat/transloco";
import { MatDialog } from "@angular/material/dialog";
import * as _ from "lodash";


@Component({
    selector: "app-block-animation-config",
    templateUrl: "./block-animation-config.component.html",
    styleUrls: ["./block-animation-config.component.scss"]
})

export class BlockAnimationConfigComponent extends BlockBaseComponent {
    @Input() showAnimationEngine = 0;
    
    isHostDevOrLocal = false;
    animationClipboard = null;

    constructor(
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        private toastr: ToastrService,
        private translocoService: TranslocoService,
    ) {
        super(storeSelector);
    }

    override onInit() {
        this.isHostDevOrLocal = isHostDevOrLocal();
        this.cod(
            this.storeSelector.listenSceneAnimationClipboard().subscribe((value: IAnimationEngine) => {
                this.animationClipboard = value;
            })
        );
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    createAnimationSlice() {
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItemId,
            values: [{
                key: 'Animation',
                value: animationDefault,
                storePath: `Data[0]`
            }]
        }));
    }

    removeAnimationSlice(event) {
        this.storeSelector.dispatch(actionRemoveInSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItemId,
            values: [{
                key: 'Animation',
                value: null,
                storePath: 'Data[0]'
            }]
        }));
    }

    devExportConfig() {
        const value: IAnimationEngine = this.sceneItem.Data[0]?.Animation?.[0];
        if (value)
            console.log(JSON.stringify(value));
    }

    copyAnimation() {
        const value: IAnimationEngine = this.sceneItem.Data[0]?.Animation?.[0];
        if (value) {
            this.storeSelector.dispatch(actionCopySceneAnimation({
                animation: value
            }));
        }
        // copyTextClipboard(JSON.stringify(value));
        // this.toastr.info(this.translocoService.translate('toast.copiedToClipboard', {}, this.translocoService.getActiveLang()), '', TOAST_FASTER);
    }

    pasteAnimation() {
        const msg = this.translocoService.translate('message.confirmPasteAnimation', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '150px',
            width: '400px',
            data: {name: `${msg}`, showCancel: true}
        });
        this.cod(
            dialogRef.afterClosed().subscribe(result => {
                if (!result) return;
                // replace animation from copied one
                this.storeSelector.dispatch(actionUpdateSceneItem({
                    sceneId: this.sceneId,
                    sceneItemId: this.sceneItemId,
                    values: [{
                        key: 'Animation',
                        value: [this.animationClipboard],
                        storePath: `Data[0]`
                    }]
                }));
                this.toastr.info(this.translocoService.translate('toast.pasteAnimationSuccess', {}, this.translocoService.getActiveLang()), '', TOAST_FASTER);
            })
        );
    }
}
